import { useAuth } from "@/components/auth/AuthProvider";

export function useIncompleteProfile(): boolean {
  const { user, loading } = useAuth();
  if (loading || !user) return false;
  return user.user_metadata?.from_waitlist === true;
}
